<template>
  <loader-wrapper :loading="loading" custom-class="edm-50">
    <div class="title green">Можно выпустить ЭЦП!</div>
    <el-form ref="form" :model="form" @submit.native.prevent>
      <el-row :gutter="35" type="flex" align="middle" class="edm-row">
        <el-col :span="6">
          <el-form-item prop="phone" :rules="rules">
            <el-input
              v-model="form.phone"
              v-mask="'+7 (###) ###-##-##'"
              placeholder="Номер телефона"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button
            type="success"
            size="mini"
            class="edm-btn"
            :loading="loading"
            @click="checkUser"
          >
            НАЧАТЬ ВЫПУСК ЭЦП
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <p v-if="error" class="edm-err">{{ error }}</p>
  </loader-wrapper>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Users = RepositoryFactory.get('users')

export default {
  name: 'CheckUser',
  components: { LoaderWrapper },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: '',
      loading: false,
      form: {
        phone: '',
      },
      rules: [
        {
          required: true,
          message: 'Телефон обязателен для заполнения',
          trigger: 'blur',
        },
        { min: 18, message: 'Телефон заполнен не полностью', trigger: 'blur' },
      ],
    }
  },
  methods: {
    checkUser() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.error = ''
          this.loading = true
          const login = this.form.phone

          Users.getUsers({ page: 0, search: { login } })
            .then(res => {
              const { status, data } = res

              if (status === 200 && data && data.items.length) {
                this.$emit('create', login)
              } else {
                this.$emit('failed')
                this.error =
                  'Пользователь не найден в системе. Водитель должен зарегистироваться и ввести данные о ИП/ООО'
              }
            })
            .catch(e => {
              this.$emit('failed')
              this.errHandler(e)
            })
            .finally(() => (this.loading = false))
        }
      })
    },
  },
}
</script>
